import React, { useRef } from "react";
import { useRemoteComponents } from "./internal/use-remote-components.js";
export function createSplitPanelLoader({ Fallback }) {
    return function SplitPanelLoader(props) {
        const ref = useRef(null);
        const components = useRemoteComponents(ref, { SplitPanel: Fallback });
        return components.SplitPanel ? React.createElement(components.SplitPanel, { ...props }) : React.createElement("div", { ref: ref });
    };
}
